import BasePerimeter from './basePerimeter';

export default new BasePerimeter({
  purpose: 'finance',
  govern: {
    'can route': function route() {
      return this.isAdmin() || this.isFDP();
    },
  },
});



// WEBPACK FOOTER //
// ./src/perimeters/financePerimeter.js